import React, { useEffect, useState } from "react";
import Player from "../Player/Player";
import Channels from "./Channels";

import {
  Box,
  Drawer,
  Button,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { loadGroup, loadPlaylist } from "../../slices/mediaSlice"; // Import your slice actions
import { fetchEpgData } from "../../slices/epgSlice"; // Import your slice actions
import { resetMemory, setGroup } from "../../other/last-opened-mode";
import { setPlaylist } from "../../actions/set-Playlist";
import { setGroupList } from "../../actions/set-Group";
import DB from "../../other/local-db";
import { setPlayingChannel } from "../../actions/playingChannel";
// location

const Live = () => {
  const [drawerOpen, setDrawerOpen] = useState(false); // Drawer state
  const playlist = useSelector((state) => state.media.playlistData);
  const epgData = useSelector((state) => state.epg.epgData);
  const epgLastUpdated = useSelector((state) => state.epg.lastUpdated);
  const dispatch = useDispatch();
  const history = useHistory();
  const { category, channel } = useParams();

  useEffect(() => {
    const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    const currentTime = Date.now();

    // Check if EPG data was updated within the last 24 hours
    if (!epgLastUpdated || (currentTime - epgLastUpdated > ONE_DAY_IN_MS)) {
      dispatch(fetchEpgData(window.epg));
    }
  }, [epgLastUpdated, dispatch]);

  useEffect(() => {
    if (channel !== undefined || playlist === undefined) {
      const gotoChannel = playlist.find((chan) => chan.num === Number(channel));
      dispatch(setPlayingChannel(gotoChannel));
    } else {
      if (playlist.length > 0) {
        history.replace(
          `/live/category/${category}/channel/${playlist[0].num}/`
        );
      } else {

      }
    }
  }, [playlist, channel, dispatch]);

  useEffect(() => {
    const fun = async () => {
      if (category !== undefined && category !== 0) {
        const chs = await dispatch(
          loadPlaylist({ mode: "live", group: category })
        ).unwrap();
        let filteredChs = chs || [];
        if (category === "fav") {
          filteredChs = filteredChs.filter((x) =>
            DB.findOne("live", x.stream_id, true)
          );
        }
        dispatch(setPlaylist(filteredChs));
      } else if (resetMemory("live")) {
        const gps = await dispatch(loadGroup("live")).unwrap();
        if (!gps || gps.length === 0) {
          history.replace("/");
          return;
        }
        const groupWithFavorites = [
          { category_name: "Favorites", category_id: "fav" },
          ...gps,
        ];
        setGroup(groupWithFavorites[1].category_id); // Assuming `setGroup` is a utility function you want to keep
        dispatch(setGroupList(groupWithFavorites));
        history.replace(
          "/live/category/" + groupWithFavorites[1].category_id + "/"
        );
      } else {
        history.replace(
          `/live/category/${window.settings.defaultCategory}/channel/${window.settings.defaultChannel}/`
        );
      }
    };
    fun();
  }, [dispatch, category, history]);

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        height: "calc(100vh - 40px)",
        zIndex: 1,
        transition: "filter 0.5s ease",
      }}
    >
      {/* Drawer for Channels */}
      <Player />
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => toggleDrawer(false)}
      >
        <Box sx={{ width: 500, padding: 2 }}>
          <Channels playlist={playlist} />
          <Button onClick={() => toggleDrawer(false)} sx={{ marginTop: 2 }}>
            Close
          </Button>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Live;
